import React from "react";
import { Switch } from "@/components/ui/switch";
import {
  SortableServiceList,
  SortableServiceItem,
} from "@/components/common/SortableServiceList";
import { HotelService, HotelServiceProviderType } from "@/types/hotelService";

const Label = ({ children, className }: any) => (
  <label className={`text-2xl font-medium ${className || ""}`}>
    {children}
  </label>
);

interface UpsellTabProps {
  settings: any;
  setSettings: (settings: any) => void;
  recommendedServices: SortableServiceItem[];
  setRecommendedServices: (items: SortableServiceItem[]) => void;
  allServices: HotelService[];
}

export const UpsellTab = ({
  settings,
  setSettings,
  recommendedServices,
  setRecommendedServices,
  allServices,
}: UpsellTabProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Switch
            checked={settings?.isUpsellRecommendedServices}
            onCheckedChange={(checked) =>
              setSettings({ ...settings, isUpsellRecommendedServices: checked })
            }
          />
          <Label>Recommended services</Label>
        </div>

        {settings?.isUpsellRecommendedServices && (
          <div className="ml-6 max-w-xl">
            <SortableServiceList
              disabled={recommendedServices.length === 3}
              items={recommendedServices}
              onReorder={setRecommendedServices}
              onRemove={(id) =>
                setRecommendedServices(
                  recommendedServices.filter((s) => s.id !== id),
                )
              }
              onAdd={(serviceId) => {
                const service = allServices.find((s) => s.id === serviceId);

                if (service) {
                  setRecommendedServices([
                    ...recommendedServices,
                    {
                      id: service.id,
                      serviceId: service.id,
                      name: service.name,
                    },
                  ]);
                }
              }}
              availableServices={allServices.filter(
                (s) =>
                  s.providerType === HotelServiceProviderType.GUEST_SERVICE,
              )}
              placeholder="Choose recommended service"
            />
          </div>
        )}
      </div>
    </div>
  );
};
